(function(){
  document.getElementById('year').textContent = new Date().getFullYear();

  // ---- Countdown -------------------------------------------------------
  // Matches the launch date already set on your Password page (Nov 1, 2026, shop timezone EEST/UTC+3).
  var LAUNCH_DATE = new Date('2026-11-01T00:00:00+03:00').getTime();

  var els = {
    d: document.getElementById('cd-days'),
    h: document.getElementById('cd-hours'),
    m: document.getElementById('cd-mins'),
    s: document.getElementById('cd-secs')
  };
  var prev = {d:null,h:null,m:null,s:null};

  function pad(n){ return String(n).padStart(2,'0'); }

  function tickIfChanged(el, key, val){
    var str = pad(val);
    if (prev[key] !== str){
      prev[key] = str;
      el.textContent = str;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        el.classList.remove('tick');
        void el.offsetWidth;
        el.classList.add('tick');
      }
    }
  }

  function render(){
    var diff = Math.max(0, LAUNCH_DATE - Date.now());
    var s = Math.floor(diff/1000);
    var days = Math.floor(s/86400);
    var hours = Math.floor((s%86400)/3600);
    var mins = Math.floor((s%3600)/60);
    var secs = s%60;
    tickIfChanged(els.d,'d',days);
    tickIfChanged(els.h,'h',hours);
    tickIfChanged(els.m,'m',mins);
    tickIfChanged(els.s,'s',secs);
  }
  render();
  setInterval(render, 1000);

  // Email capture is handled entirely by the Shopify Forms app block
  // (Form ID 1160254), added as its own section on the Password template.
  // No custom form JS lives on this page anymore.
})();